import { Box, BoxProps } from "@mui/material";

const CodeSpinnerIcon = (props: BoxProps) => {
  return (
    <Box
      component="object"
      type="image/svg+xml"
      data="/svg/spinner.svg"
      {...props}
      sx={{
        width: 100,
        ...props.sx,
      }}
    ></Box>
  );
};

export { CodeSpinnerIcon };
